import { IType } from './implement';
import { IMap } from 'interfaces';
import { t } from 'i18n';
import dayjs from 'dayjs';
import dateTimeConstants from './datetime';

const { YEAR_DASH_FORMAT } = dateTimeConstants;

export type ITypeString = IMap<{ value: string; label: string }>;

const DEFAULT_PARAMS = {
  page: 1,
  pageSize: 10,
};

const DEFAULT_PARAMS_ALL = {
  page: 1,
  pageSize: 1000,
};
const LEVEL_TRANSACTION: IType = {
  S0: {
    label: 'S0',
    value: 0,
  },
  S1: {
    label: 'S1',
    value: 1,
  },
  S2: {
    label: 'S2',
    value: 2,
  },
  S3: {
    label: 'S3',
    value: 3,
  },
  S4: {
    label: 'S4',
    value: 4,
  },
  S5: {
    label: 'S5',
    value: 5,
  },
  S10: {
    label: 'S10',
    value: 10,
  },
};

export type ITypeScreen = IMap<{
  value: number;
  label: string;
  companies?: number[];
}>;

const SCREEN_IN_REPORT: ITypeScreen = {
  NEW_SHOP_LIST: {
    label: 'DS shop QR mở mới',
    value: 1,
    companies: [window.COMPANY_ID_DIGILIFE, window.COMPANY_ID_VNNG],
  },
  REPORT_SUMMARY: {
    label: 'BC tổng hợp',
    value: 2,
    companies: [window.COMPANY_ID_VNNG],
  },
  LIST_SHOP_TAKE_CARE: {
    label: 'DS shop QR chăm sóc',
    value: 3,
    companies: [window.COMPANY_ID_DIGILIFE, window.COMPANY_ID_VNNG],
  },
  SPOS_CONTRACT_LIST: {
    label: 'Ds hồ sơ SPOS',
    value: 4,
    companies: [
      window.COMPANY_ID_DIGILIFE,
      window.COMPANY_ID_VNNG,
      window.COMPANY_ID_NAB,
    ],
  },
  TIMESHEET_REPORT: {
    label: 'Báo cáo chấm công',
    value: 5,
    companies: [window.COMPANY_ID_CRM_TEKO],
  },
};

//daily report
const DAILY_REPORT_SORT_BY: IType = {
  PerformanceASC: {
    label: t('DailyReport.PerformanceASC'),
    value: 0,
  },
  PerformanceDESC: {
    label: t('DailyReport.PerformanceDESC'),
    value: 1,
  },
  // KPIASC: {
  //   label: t('DailyReport.KPIASC'),
  //   value: 2,
  // },
  // KPIDESC: {
  //   label: t('DailyReport.KPIDESC'),
  //   value: 3,
  // },
};

const REPORTABLE_ACCORDING_TO: IType = {
  BY_DATE: {
    label: t('DailyReport.ByDate'),
    value: 0,
  },
  ACCUMULATED: {
    label: t('DailyReport.Accumulated'),
    value: 1,
  },
};

const DEFAULT_PARAMS_DAILY_REPORT = {
  page: 1,
  pageSize: 10,
  reportDate: dayjs().format(YEAR_DASH_FORMAT),
};

const TAKE_CARE_STATUS = {
  TAKING_CARE: {
    value: 0,
    label: t('ListShopTakeCare.TakingCare'),
  },
  STOP_TAKE_CARE: {
    value: 1,
    label: t('ListShopTakeCare.StopTakeCare'),
  },
};

const SHOP_TYPE_DICT: {
  [key: string]: {
    value: number;
    label: string;
    class: string;
    searchLabel: string;
  };
} = {
  1: {
    value: 1,
    label: t('NewShop.NewShopTag'),
    class: 'tag-shop-new',
    searchLabel: t('NewShop.TypeNewShop'),
  },
  2: {
    value: 2,
    label: t('NewShop.AdditionalShopTag'),
    class: 'tag-shop-add',
    searchLabel: t('NewShop.TypeAdditionalShop'),
  },
};

export default {
  DEFAULT_PARAMS,
  DEFAULT_PARAMS_ALL,
  SCREEN_IN_REPORT,
  LEVEL_TRANSACTION,
  MAX_K: 5,
  MAX_T: 10,
  MAX_T_VNNG: 150,
  DAILY_REPORT_SORT_BY,
  DEFAULT_PARAMS_DAILY_REPORT,
  REPORTABLE_ACCORDING_TO,
  MAX_GMV: 2000000,
  TAKE_CARE_STATUS,
  SHOP_TYPE_DICT,
};
